import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'

import clip from 'text-clipper'

import './HTMLViewer.scss'

const HTMLViewer = ({
  encoded,
  fullPage,
  truncate,
  width,
  data,
  color,
  margin,
  padding,
}) => {
  const ref = useRef()
  const [height, setHeight] = useState(100)

  const decode = (value) => {
    try {
      return window.atob(value)
    } catch (error) {
      return value
    }
  }

  const getBodyContent = (value) => {
    try {
      const parser = new DOMParser()
      const doc = parser.parseFromString(value, 'html')

      return doc.body.innerText
    } catch (err) {
      return value
    }
  }

  const onLoad = () => {
    if (ref.current) {
      const h = ref.current.contentWindow.document.body.scrollHeight + 20
      setHeight(h + 'px')
    }
  }

  const decoded = encoded ? decode(data) : data
  const html = fullPage ? decoded : getBodyContent(decoded)
  const content = truncate ? clip(html, truncate, { html: true }) : html

  if (fullPage) {
    return (
      <iframe
        ref={ref}
        style={{
          color,
          margin,
          padding,
        }}
        width={width}
        height={height}
        srcDoc={content}
        frameBorder={0}
        scrolling="no"
        onLoad={onLoad}
      ></iframe>
    )
  }

  return (
    <div
      className="x-html-viewer"
      style={{
        color,
        margin,
        padding,
      }}
      dangerouslySetInnerHTML={{
        __html: content,
      }}
    ></div>
  )
}

HTMLViewer.propTypes = {
  margin: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  padding: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  encoded: PropTypes.bool,
  fullPage: PropTypes.bool,
  truncate: PropTypes.number,
  width: PropTypes.string,
  data: PropTypes.string,
}

HTMLViewer.defaultProps = {
  margin: null,
  padding: null,
  color: '#000000',
  encoded: true,
  fullPage: false,
  truncate: 0,
  width: '100%',
  data: '',
}

export default HTMLViewer
